import { render, staticRenderFns } from "./salesforce.vue?vue&type=template&id=4446ffd6&scoped=true&"
import script from "./salesforce.vue?vue&type=script&lang=js&"
export * from "./salesforce.vue?vue&type=script&lang=js&"
import style0 from "./salesforce.vue?vue&type=style&index=0&id=4446ffd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4446ffd6",
  null
  
)

export default component.exports